// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2o6Q4","option":"styles_option__8MzCm","active":"styles_active__1HTA9"};